module.exports = __webpack_public_path__ + "img/GitHub_Logo.cefc2023.png";